import GenerateReport from "./views/GenerateReport.vue";
import PayslipReport from "./views/PayslipReport.vue";

export default [
  {
    path: "generate",
    component: GenerateReport,
  },
  {
    path: "payslip",
    name: "payslip",
    component: PayslipReport,
  },
];
